import { handleActions } from 'redux-actions'
import {
  wssOpened,
  wssEndpointFetchFulfilled,
  wssEndpointFetch,
  wssEndpointFetchRejected,
  wssClosed
} from '../actions/wss'

const initialState = {
  wssState: ''
}

export const wssReducer = handleActions({
  [wssEndpointFetch] (prevState) {
    return {
      ...prevState,
      wssState: 'FETCH_ENDPOINT'
    }
  },
  [wssEndpointFetchFulfilled] (prevState) {
    return {
      ...prevState,
      wssState: 'OPENING'
    }
  },
  [wssEndpointFetchRejected] (prevState) {
    return {
      ...prevState,
      wssState: 'ERROR'
    }
  },
  [wssOpened] (prevState) {
    return {
      ...prevState,
      wssState: 'OPENED'
    }
  },
  [wssClosed] (prevState) {
    return {
      ...prevState,
      wssState: 'CLOSED'
    }
  }
}, initialState)
